import { occurrenceSchema, type Occurrence } from '@klopotun/contracts';
import { apiRequest } from '../../../../shared/api/index.js';

const postVoid = (id: string): Promise<unknown> =>
  apiRequest<unknown>(`/occurrences/${id}/void`, { method: 'POST' });

export const voidOccurrence = async (id: string): Promise<Occurrence> =>
  occurrenceSchema.parse(await postVoid(id));
